import { render } from "./UiCheckbox.vue?vue&type=template&id=5ee4d178"
const script = {}

import "./UiCheckbox.vue?vue&type=style&index=0&id=5ee4d178&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__